import { Clickable } from '@carvana/merch-components';
import { useEffect, useRef, useState } from 'react';
import { SearchBar } from '@/sem/SearchBar';
import UpArrow from '~/icons/UpArrow';
import { Banner, SearchBarWrapper, Top } from './StickyBanner.styles';

function useShowBanner(markerRef: React.RefObject<HTMLDivElement>) {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (!markerRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]: IntersectionObserverEntry[]): void => {
        setShowBanner(!entry.isIntersecting);
      },
      {}
    );

    observer.observe(markerRef.current);

    return () => {
      observer.disconnect();
    };
  }, [markerRef]);

  return showBanner;
}

export default function StickyBanner() {
  const markerRef = useRef<HTMLDivElement>(null);
  const showBanner = useShowBanner(markerRef);

  return (
    <>
      <div ref={markerRef} />

      {showBanner ? (
        <Banner>
          <Clickable
            element={Top}
            onClick={() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            data-analytics-id="Sticky Banner - Top"
          >
            <UpArrow className="h-16 w-16" />
            Top
          </Clickable>

          <SearchBarWrapper>
            <SearchBar id="sticky-banner" />
          </SearchBarWrapper>
        </Banner>
      ) : (
        <div />
      )}
    </>
  );
}
